import styled from 'styled-components';

export const LeftBlockMainWrap = styled.div(
    props => `
        width:75%;
        display: flex;
        flex-direction: column;
        padding-right: ${props.theme.spacing.large.l30};
    `
);